import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from "react-intl";

import {useFormikContext} from "formik";

import CustomCheckbox from "components/checkbox/CustomCheckbox";

import getNestedValue from "utils/getNestedValue";

CheckboxTypeField.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    noPadding: PropTypes.bool,
    checked: PropTypes.bool
};

function CheckboxTypeField({name, label, required = false, disabled = false, noPadding = false, checked = false, ...props}) {
    const {values, setFieldValue} = useFormikContext();

    return (
        <CustomCheckbox
            disabled={disabled}
            required={required}
            noPadding={noPadding}
            checked={getNestedValue(values, name) ?? checked}
            onChange={(event) => setFieldValue(name, event.target.checked)}
            label={props.intl.formatMessage({id: label})}
        />
    );
}

export default injectIntl(CheckboxTypeField);
